
import { defineComponent, ref } from 'vue';

import { TestimonialModal, Testimonials } from '@/components/testimonial';
import testimonials from '@/data/testimonials';

export default defineComponent({
  name: 'TestimonialPopupList',
  components: {
    TestimonialModal,
    Testimonials,
  },
  setup() {
    const currentPopupTestimonial = ref(null);

    const introTestimonials = Object.entries(testimonials).map(([id, testimonial]) => ({
      id,
      name: testimonial.name,
      icon: testimonial.icon,
      suffix: `(${testimonial.state.age})`,
      content: testimonial.text.intro,
    }));

    const setPopupTestimonial = (testimonial) => {
      currentPopupTestimonial.value = testimonials[testimonial.id];
    };

    const closePopupTestimonial = () => {
      currentPopupTestimonial.value = null;
    };

    return {
      testimonials: introTestimonials,
      currentPopupTestimonial,
      setPopupTestimonial,
      closePopupTestimonial,
    };
  },
});
